import Vue, { createApp } from 'vue';
import VueAnalytics from 'vue-analytics';
//import axios from 'axios'
import App from './App.vue';
import VueMeta from 'vue-meta'
import VueRouter from 'vue-router';
import Vuex from 'vuex'
import {BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
// import 'bootstrap/dist/css/bootstrap.css';
// import 'bootstrap-vue/dist/bootstrap-vue.css';
import './scss/custom.scss';
import router from './routes';
//import SmartTable from 'vuejs-smart-table';
import store from './store/store';

// CHANGED (Dec 2024 - Vue 3 Migration): Import compat components for Vue 3 support
// WHO: GitHub Copilot (Claude Sonnet 4.5)
// WHY: BootstrapVue incompatible with Vue 3; provides bridge components
import { CompatComponents } from '@/components/compat';

// 20260416 -- Copilot (Claude Sonnet 4.6) -- Import ColorSwatchPicker for global registration
import ColorSwatchPicker from '@/components/blocks/ColorSwatchPicker.vue';

// Import the Auth0 configuration
// import { audience, domain, clientId } from "../auth_config.json";

// Import the plugin here
import { Auth0Plugin, getInstance } from "./auth";

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueMeta, {
  tagIDKeyName: 'description'
})

Vue.use(VueRouter);
Vue.use(Vuex);

// 20200122 -- ZWS -- Removed moment and momentTZ to stop a error in the browser console.
//Vue.use(moment)
//Vue.use(momentTZ)

//sVue.use(SmartTable);

// Install the authentication plugin here

let audience = process.env.VUE_APP_ENV_AUTH0_AUDIENCE
let domain = process.env.VUE_APP_ENV_AUTH0_DOMAIN
let clientId = process.env.VUE_APP_ENV_AUTH0_CLIENT_ID

// 20260128 -- Copilot (Claude Sonnet 4.5) -- Removed console.log of Auth0 config
// WHY: Sensitive configuration should not be exposed in browser console

const app = createApp(App);

app.use(store);

// CHANGED (Dec 2024 - Vue 3 Migration): Register compatibility components
// WHO: GitHub Copilot (Claude Sonnet 4.5)
// WHY: Provides Vue 3-compatible replacements for BootstrapVue form components
//      (b-form-checkbox, b-form-select, b-form-radio, etc.)
app.use(CompatComponents);

// 20260416 -- Copilot (Claude Sonnet 4.6) -- Register ColorSwatchPicker globally for context and folder color assignment
app.component('ColorSwatchPicker', ColorSwatchPicker);
app.component('color-swatch-picker', ColorSwatchPicker);

app.use(Auth0Plugin, {
  audience,
  domain,
  clientId,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
});

// 20260520 -- Copilot (Claude Sonnet 4.6) -- Expose auth instance for Cypress testing
// WHY: Allows tests to stub loginWithRedirect to prevent actual Auth0 redirect when exercising
//      the adminGuard reauth path. Only active when window.Cypress is defined (Cypress test runs).
if (window.Cypress) {
  window.__auth0 = getInstance()
}

app.use(router);

// Load subscription products on app initialization
if (store.state.userToken) {
  store.dispatch('loadSubscriptionProducts').catch(err => {
    // 20260128 -- Copilot (Claude Sonnet 4.5) -- Removed console.warn
    // WHY: Non-critical on init, error logged server-side if needed
  });
}

// Don't configure Google Analytics unless in Prod
if(process.env.NODE_ENV === 'production') {
  app.use(VueAnalytics, {
    id: 'UA-1847837-9',
    router
  });
}

app.config.devtools = true;

app.mount("#app");